<section>
  <!-- <cash-value-component [data]="data"></cash-value-component> -->
</section>
<div class="flex items-start justify-between pl-0 pr-0 w-full h-[65px] mt-4">
  <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="back()">
    <span class="flex items-center gap-2 text-[#18191C]"
      ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
    >
  </button>
  <div class="w-[158px]">
    <button type="submit" (click)="save()" class="app__btn--primary mt-0">Continue</button>
  </div>
</div>
